import { ReactNode } from "react";

const FormRow: React.FC<FormRowProps> = ({ children, className }) => (
    <div className={`row${className ? ' ' + className : ''}`}>{children}</div>
);

interface FormRowProps {
    children: ReactNode;
    className?: string;
}

export default FormRow;
